webpackJsonp([103555066157098],{

/***/ 1343:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.tagPageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Typography = __webpack_require__(18);
	
	var _evergreenUi = __webpack_require__(24);
	
	var _gatsbyImage = __webpack_require__(17);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styledFlexComponent = __webpack_require__(23);
	
	var _styledFlexComponent2 = _interopRequireDefault(_styledFlexComponent);
	
	var _lodash = __webpack_require__(73);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagRoute = function (_React$Component) {
		_inherits(TagRoute, _React$Component);
	
		function TagRoute() {
			_classCallCheck(this, TagRoute);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		TagRoute.prototype.render = function render() {
			var posts = this.props.data.tags.edges;
			var tag = this.props.pathContext.tag;
			var totalCount = this.props.data.tags.totalCount;
			var tagHeader = totalCount + " post" + (totalCount === 1 ? "" : "s") + " tagged with \u201C" + tag + "\u201D";
	
			console.log(posts);
	
			return _react2.default.createElement(
				"section",
				{ className: "section" },
				_react2.default.createElement(_reactHelmet2.default, { title: tag }),
				_react2.default.createElement(
					_Typography.CenteredFull,
					null,
					_react2.default.createElement(
						_Typography.Title,
						null,
						tagHeader
					)
				),
				_react2.default.createElement(
					Grid,
					null,
					posts.map(function (post) {
						if (post.node.fields) {
							return _react2.default.createElement(
								_gatsbyLink2.default,
								{ to: post.node.fields.slug },
								_react2.default.createElement(
									_evergreenUi.Card,
									{ elevation: 1, key: post.node.fields.slug },
									_react2.default.createElement(
										_styledFlexComponent2.default,
										{ alignCenter: true, full: true },
										_react2.default.createElement(
											_styledFlexComponent.FlexItem,
											{ style: { alignSelf: "flex-start" } },
											post.node.frontmatter.featured_image && _react2.default.createElement(BlogImage, { resolutions: post.node.frontmatter.featured_image.childImageSharp.resolutions })
										),
										_react2.default.createElement(
											_styledFlexComponent.FlexItem,
											{ style: { padding: "1rem" } },
											_react2.default.createElement(
												_styledFlexComponent2.default,
												{ column: true },
												_react2.default.createElement(
													_evergreenUi.Strong,
													{ size: 700 },
													_lodash2.default.truncate(post.node.frontmatter.title, { length: 60, separator: " " })
												),
												_react2.default.createElement(
													_evergreenUi.Strong,
													{ size: 200, color: _evergreenUi.colors.green },
													post.node.frontmatter.date
												),
												_react2.default.createElement(
													_evergreenUi.Text,
													null,
													_lodash2.default.truncate(post.node.frontmatter.description, { length: 60, separator: " " })
												)
											)
										)
									)
								)
							);
						} else {
							return "";
						}
					}),
					_react2.default.createElement(
						_evergreenUi.Button,
						{ style: { justifySelf: "flex-start" } },
						_react2.default.createElement(
							_gatsbyLink2.default,
							{ to: "/tags/" },
							"Browse all tags"
						)
					)
				)
			);
		};
	
		return TagRoute;
	}(_react2.default.Component);
	
	var BlogImage = (0, _styledComponents2.default)(_gatsbyImage2.default).withConfig({
		displayName: "tags__BlogImage"
	})(["margin-right:15px;border-radius:10px;@media screen and (max-width:600px){width:80px !important;height:80px !important;border-radius:5px;}"]);
	
	var Grid = _styledComponents2.default.div.withConfig({
		displayName: "tags__Grid"
	})(["display:grid;grid-template-columns:repeat(auto-fit,500px);grid-gap:35px 50px;justify-content:center;margin-bottom:5rem;@media screen and (max-width:500px){grid-template-columns:repeat(auto-fit,calc(100vw / 24 * 22));grid-gap:25px 0;}"]);
	
	exports.default = TagRoute;
	var tagPageQuery = exports.tagPageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tags-jsx-632be5749aa61a5a8d23.js